import html2pdf from 'html2pdf.js';
import { toast } from 'react-toastify';
import DOMPurify from 'dompurify';

export const generateweekylyTransactionBill = (reservations, weekStartDate, weekEndDate ,invoiceAddress , serialNo) => {

  if(!invoiceAddress){
    toast.info("Comming soon",{
      autoClose:1000
    })
    return
  }

  const hostelId = reservations[0]?.hostelId
  let startDate = weekStartDate?.split("-").reverse().join("")
  let endDate = weekEndDate?.split("-").reverse().join("")
  let invoiceNo = `${hostelId}${startDate}${endDate}`
 const quantity = reservations.reduce((acc, r) => {
  const checkIn = new Date(r.checkInDate);
  const checkOut = new Date(r.checkOutDate);
  const diffMs = checkOut - checkIn;
  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  const rooms = r.totalRooms ?? 1; 
  return acc + (diffDays * rooms);
}, 0);

const Dated = new Date(weekEndDate)
Dated.setDate(Dated.getDate() + 2)

  const invoiceHTML = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width,initial-scale=1" />
  <title>Tax Invoice - Preview</title>
  <style>
    /* Page styling */
    body {
      font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
      font-size: 11px;
      color: #000;
      margin: 12px;
      background: #fff;
    }

    .page {
      width: 750px;
  margin: 0 auto;
  border: 1px solid #000;
  padding: 8px;
  box-sizing: border-box;
    }

    h2.title {
      text-align: center;
      margin: 2px 0 6px;
      font-weight: 700;
      font-size: 16px;
    }

    table { border-collapse: collapse; width: 100%; }
    td, th { border: 0.2px solid #00000070; padding: 4px; vertical-align: top; }
    .no-border { border: none !important; }
    .inner-no-border td { border: none; padding: 2px; }

    /* top header layout */
    .top-row td { border: 0.px solid #00000070; padding: 6px; }
    .seller {
      width: 58%; 
      font-size: 11px;
    }
    .invoice-box {
    width: 42%;
    }
    .invoice-grid { width: 100%; border-collapse: collapse; table-layout: fixed;  padding: 0;}
    .invoice-grid td { border-bottom: 1px solid #00000070; border-top: 0; border-left: 1px; border-right: 0; padding: 4px;  font-size: 11px; }

    /* buyer/consignee */
    .party-block td { padding: 6px; font-size: 11px; }

    /* items table */
    .items thead th { background: #f2f2f2; text-align: center; font-weight: 700; }
    .items { table-layout: fixed; }
    .items th, .items td { font-size: 11px; padding: 6px; }
    .col-sl { width: 4%; text-align: center; }
    .col-part { width: 50%; text-align: left; padding-left: 8px; }
    .col-hsn { width: 8%; text-align: center; } 
    .col-gst { width: 7%; text-align: center; }
    .col-qty { width: 8%; text-align: center; }
    .col-rate { width: 7%; text-align: center; }
    .col-per { width: 6%; text-align: center; }
    .col-amt { width: 10%; text-align: right; padding-right: 8px; }

    /* totals and small summary */
    .totals-row td { border-top: 1px solid #00000070; }
    .amount-words { margin-top: 6px; padding: 8px 6px; border: 1px solid #00000070; font-size: 11px; }

    .hsn-table td { font-size: 11px; padding: 4px; }
    .bank-sign { margin-top: 8px; font-size: 11px; }
    .bank-left { width: 65%; vertical-align: top; padding: 6px; }
    .sign-right { width: 35%; text-align: center; vertical-align: top; padding: 6px; }

    .footer-note { text-align: center; margin-top: 8px; font-size: 10px; }
    .small { font-size: 10px; }
    .muted { color: #111; opacity: 0.9; }

    /* make long particulars wrap */
    .particulars p { margin: 2px 0; line-height: 1.1; font-size: 10.5px; }
  </style>
</head>
<body>

<div class="page">
  <h2 class="title">Tax Invoice</h2>

  <!-- Header: Seller left, Invoice details right -->
  <table class="top-row" style="margin-bottom:6px;">
    <tr>
      <td class="seller">
        <strong>Shaplago Products LLP</strong><br/>
        Old Airport Road, Flat No. 507<br/>
        Golf Manor Apartments, Vimanapura, Bengaluru<br/>
        Karnataka - 560017<br/>
        GSTIN: 29AETFS1592J1Z5<br/>
        State Name: Karnataka, Code: 29<br/>
        Contact: +91 9673203092 <br/>
        E-MAIL: palash@thehostelco.com
      </td>

      <td class="invoice-box">
        <table class="invoice-grid">
          <tr>
<td style="
  width: 50%; 
  border-right: 1px solid rgba(0, 0, 0, 0.529);
  word-break: break-word;
  white-space: normal;
">
  Invoice No.<br/>
  <strong>${invoiceNo}</strong>
</td>
            <td style="width: 50%;">Dated<br/><strong>${Dated.toISOString().split("T")[0]}</strong></td>
          </tr>
          <tr>
            <td style="width: 50%; border-right: 1px solid rgba(0, 0, 0, 0.529);">Delivery Note</td>
            <td>Mode/Terms of Payment</td>
          </tr>
          <tr>
             <td style="width: 50%; border-right: 1px solid rgba(0, 0, 0, 0.529);">Reference No. &amp; Date<br/><strong>dt. ${Dated}</strong></td>
            <td>Other References</td>
          </tr>
          <tr>
             <td style="width: 50%; border-right: 1px solid rgba(0, 0, 0, 0.529);">Buyer's Order No.</td>
            <td>Dated</td>
          </tr>
          <tr>
             <td style="width: 50%; border-right: 1px solid rgba(0, 0, 0, 0.529);">Dispatch Doc No.</td>
            <td>Delivery note date</td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <!-- Consignee / Buyer / Dispatch (three columns layout where right column blank) -->
  <table style="margin-bottom:6px;">
    <tr>
      <td style="width:48%; vertical-align:top;">
        <table style="width:100%;">
          <tr><td style="border:none; padding:0;">
            <strong>Consignee (Ship to)</strong><br/>
                ${invoiceAddress.hostelName}<br/>
     ${invoiceAddress.consigneeAddress}<br/>
     ${invoiceAddress.state || ""}
                     <br/> GSTIN:${invoiceAddress.GSTIN}

          </td></tr>
        </table>
      </td>

      <td style="width:52%; vertical-align:top;">
        <table style="width:100%; border-collapse: collapse;">
          <tr><td style="border:none; padding:0;">
            <strong>Buyer (Bill to)</strong><br/>
                 ${invoiceAddress.hostelName}<br/>
     ${invoiceAddress.consigneeAddress}<br/>
     ${invoiceAddress.state || ""}
                     <br/> GSTIN:${invoiceAddress.GSTIN || ""}
          </td></tr>
        </table>
      </td>
    </tr>
  </table>

  <!-- Items table -->
  <table class="items" style="margin-bottom:6px; ">
    <thead>
      <tr>
        <th class="col-sl">Sl<br/>No.</th>
        <th class="col-part">Particulars</th>
        <th class="col-hsn">HSN / SAC</th>
        <th class="col-gst">GST<br/>Rate</th>
        <th class="col-qty">Quantity</th>
        <th class="col-rate">Rate</th>
        <th class="col-per">Per</th>
        <th class="col-amt">Amount</th>
      </tr>
    </thead>
    <tbody>
      <!-- big particulars cell like your screenshot -->
   
${
  reservations.map((r,index) =>{

      const checkIn = new Date(r.checkInDate);
  const checkOut = new Date(r.checkOutDate);
  const diffMs = checkOut - checkIn;
  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  const quantity = r.totalRooms * diffDays
    return   ` <tr>
        <td class="col-sl" style="text-align:center;">${index+1}</td>
        <td class="col-part particulars">
          <p style="font-weight:700;">Commission Inter State 18%</p>
          <p style="font-size:10px; margin-top:6px;">
            Commission for Booking Services<br/>
            Customer Name: ${r.customerName}<br/>
            One Day Accommodation Services<br/>
            Booking Id: ${r.booking_id}<br/>
            Date of Booking: ${r.bookingDate.split("T")[0]}<br/>
            Check In Date &amp; Time: ${r.checkInDate}
          </p>
          <p style="font-weight:700; text-align:left; margin-top:6px;">Output IGST @ 18%</p>
        </td>
        <td class="col-hsn">998554</td>
        <td class="col-gst">18 %</td>
        <td class="col-qty">${quantity }</td>
        <td class="col-rate">21.19</td>
        <td class="col-per">each</td>
        <td class="col-amt">${(quantity * 21.19).toFixed(2)}</td>
      </tr> `
  }).join("")
}

      <!-- GST row (displaying GST amount on the right similar to screenshot) -->
      <tr>
        <td class="col-sl" style="border-top:0; border-bottom:0;"></td>
        <td class="col-part" style="border-top:0; border-bottom:0;"></td>
        <td class="col-hsn" style="border-top:0; border-bottom:0;"></td>
        <td class="col-gst" style="border-top:0; border-bottom:0; text-align:center; font-weight:700;">18 %</td>
        <td class="col-qty" style="border-top:0; border-bottom:0;"></td>
        <td class="col-rate" style="border-top:0; border-bottom:0;"></td>
        <td class="col-per" style="border-top:0; border-bottom:0;"></td>
        <td class="col-amt" style="border-top:0; border-bottom:0;">${((quantity * 21.19) * 0.18).toFixed(2)}</td>
      </tr>

      <tr style="height:40px;">
        <td colspan="8" style="border-top:0; text-align:left; padding:0; border-left:1px solid #00000070; border-right:1px solid #00000070;"></td>
      </tr>

      <!-- Totals row -->
      <tr class="totals-row">
        <td colspan="7" style="text-align:right; font-weight:700; padding-right:8px;">Total</td>
        <td style="text-align:right; font-weight:700; padding-right:8px;">₹ ${((quantity * 21.19)  + ((quantity * 21.19) * 0.18)).toFixed(2)}</td>
      </tr>
    </tbody>
  </table>




  <!-- Tax amount in words and Bank details / signature -->
  <table style="margin-top:6px;">
    <tr>
        <div style="margin-top:10px; font-size:11px;">
          <strong>Company's Bank Details</strong><br/>
          A/c Holder's Name : Shapalgo Products  LLP<br/>
          Bank Name : HDFC BANK<br/>
          A/c No. : 5020 0076 7585 28 <br/>
          Branch &amp; IFS Code : OLD AIRPORT ROAD, HDFC0000075 <br/>
        </div>

        <div style="margin-top:10px; font-size:10px;">
          <strong>Remarks:</strong><br/>
          SH 01
        </div>

        <div style="margin-top:8px; font-size:10px;">
          <strong>Declaration</strong><br/>
          We declare that this invoice shows the actual price of the service described and that all particulars are true and correct.
        </div>
      </td>

  
    </tr>
  </table>

  <!-- small signature line and footer -->
  <div style="margin-top:8px;">
    <table style="width:100%;">
      <tr>
        <td style="height:40px; border-top:1px solid #00000070; border-bottom:1px solid #00000070; border-left:1px solid #00000070; border-right:0px solid #00000070;">Customer sales and signature</td>
        <td style="height:40px; border:1px solid #00000070;   display: flex; flex-direction: column; justify-content: space-between; align-items: end;">
          <div style="font-weight: 700;">For shapalgo products LLp</div>
          <div> Authorised Signatory</div>
        </td>
      </tr>
    </table>
  </div>

  <div class="footer-note small muted">
    SUBJECT TO KARNATAKA JURISDICTION<br/>
    This is a Computer Generated Invoice
  </div>
</div>

</body>
</html>

  `;

  const element = document.createElement('div');
element.innerHTML = DOMPurify.sanitize(invoiceHTML, { WHOLE_DOCUMENT: true });

  html2pdf().set({
    margin: 5,
    filename: `invoice_${weekStartDate}_${weekEndDate}.pdf`,
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  }).from(element).save();
};
